
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rss",
      function () {
        return require("private-next-pages/rss.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rss"])
      });
    }
  